import React from 'react';
import { Box, Typography, Chip, Button } from '@mui/material';
import EntityActionsDialog from './EntityActionsDialog';
import { formatDateShort, formatCents, subscriptionStatusColor as statusColor } from '../utils/formatters';

function SubscriptionSummary(sub) {
  return (
    <Box sx={{ bgcolor: 'grey.50', borderRadius: 1, p: 2, mb: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          {sub.user_name || sub.email}
        </Typography>
        <Chip
          label={sub.status?.replace(/_/g, ' ')}
          color={statusColor(sub.status)}
          size="small"
          variant="outlined"
        />
      </Box>
      {sub.user_name && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
          {sub.email}
        </Typography>
      )}
      <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
        <Box>
          <Typography variant="caption" color="text.secondary">Product</Typography>
          <Typography variant="body2">{sub.product_name}</Typography>
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">Plan</Typography>
          <Typography variant="body2">
            {sub.plan_name} — {formatCents(sub.price_cents)}/{sub.interval_type === 'year' ? 'yr' : 'mo'}
          </Typography>
        </Box>
        {sub.current_period_end && (
          <Box>
            <Typography variant="caption" color="text.secondary">
              {!!sub.cancel_at_period_end ? 'Cancels' : 'Renews'}
            </Typography>
            <Typography variant="body2">{formatDateShort(sub.current_period_end)}</Typography>
          </Box>
        )}
      </Box>
      {!!sub.cancel_at_period_end && (
        <Chip label="Canceling at period end" color="warning" size="small" sx={{ mt: 1 }} />
      )}
    </Box>
  );
}

export default function SubscriptionActionsDialog({ open, onClose, subscriptionId, onRunWorkflow, onRetryPayment }) {
  return (
    <EntityActionsDialog
      open={open}
      onClose={onClose}
      entityType="subscription"
      entityId={subscriptionId}
      title="Subscription Actions"
      renderSummary={SubscriptionSummary}
      onRunWorkflow={onRunWorkflow}
      extraActions={(sub) => sub.status === 'past_due' ? (
        <Button
          variant="outlined"
          color="warning"
          size="small"
          onClick={() => onRetryPayment(subscriptionId)}
          sx={{ textTransform: 'none' }}
        >
          Retry Payment
        </Button>
      ) : null}
    />
  );
}
